// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog{width:60%}.chooseCourse{margin-right:10px;font-size:12px;line-height:30px}.courseChoose .courses{display:block;padding-left:5%;padding-top:10px}.courseChoose{width:25%;float:left;border-right:1px dashed #ccc;margin-top:20px;padding-bottom:10px}.courseChoose:last-child{border-right:none}.el-checkbox__label{white-space:normal;padding-left:5px}.focusing .el-icon-close-tip{display:none!important}", ""]);
// Exports
module.exports = exports;
